// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* home.css */
.home-container {
    background-color: #303030;
    color: white;
    font-family: Arial, sans-serif;
    margin: 0;
    padding: 0;
    min-height: 100vh; /* Changed from height */
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    overflow: auto; /* Allow scrolling */
    flex-direction: column; /* Optional: helps with vertical stacking */
}


.inner-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    max-width: 1200px;
    width: 100%;
    justify-content: center;
    gap: 70px;
}

.text-content {
    flex: 1 1;
    max-width: 500px;
}

.hero-title {
    font-size: 40px;
    line-height: 1.2;
    margin-bottom: 24px;
    font-family: 'GlitchGoblin', sans-serif;
    text-align: left;
    color: #FFFFFF;
}

.hero-description {
    font-size: 15px;
    line-height: 1.6;
    margin: 50px 0px;
    color: #FFFFFF;
    max-width: 500px;
    text-align: left;
}

.button-group {
    display: flex;
    gap: 16px;
}

.cta-button {
    padding: 12px 32px;
    font-size: 16px;
    border-radius: 5px;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.3s ease;
}

.primary-cta {
    background-color: #007bff;
    color: #FFFFFF;
    border: none;
}

.secondary-cta {
    background-color: transparent;
    color: #FFFFFF;
    border: 2px solid #FFFFFF;
}

.hero-image {
    flex: 1 1;
    max-width: 400px;
    height: 480px;
    margin-top: 5%;
}

/* Mobile View */
@media (max-width: 768px) {
    .hero-title {
        font-size: 40px;
        margin: 10vh 0vh;
        text-align: center;
    }
    
    .inner-container {
        flex-direction: column;
        text-align: center;
        gap: 100px;
        margin-top: 80px;
    }

    .hero-description {
        font-size: 18px;
        max-width: 100%;
        margin: 80px 10px;
        text-align: center;
    }

    .button-group {
        flex-direction: column;
        width: 100%;
        max-width: 400px;
        align-items: center;
    }

    .cta-button {
        width: 100%;
        text-align: center;
        height: 60px;
    }

    .hero-image {
        max-width: 90%;
        height: auto;
    }
    
    .text-content {
        max-width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 8vh 2vh;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Home.css"],"names":[],"mappings":"AAAA,aAAa;AACb;IACI,yBAAyB;IACzB,YAAY;IACZ,8BAA8B;IAC9B,SAAS;IACT,UAAU;IACV,iBAAiB,EAAE,wBAAwB;IAC3C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,cAAc,EAAE,oBAAoB;IACpC,sBAAsB,EAAE,2CAA2C;AACvE;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uCAAuC;IACvC,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,cAAc;AAClB;;AAEA,gBAAgB;AAChB;IACI;QACI,eAAe;QACf,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;QAClB,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,WAAW;QACX,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,YAAY;IAChB;;IAEA;QACI,cAAc;QACd,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,gBAAgB;IACpB;AACJ","sourcesContent":["/* home.css */\n.home-container {\n    background-color: #303030;\n    color: white;\n    font-family: Arial, sans-serif;\n    margin: 0;\n    padding: 0;\n    min-height: 100vh; /* Changed from height */\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    overflow: auto; /* Allow scrolling */\n    flex-direction: column; /* Optional: helps with vertical stacking */\n}\n\n\n.inner-container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    max-width: 1200px;\n    width: 100%;\n    justify-content: center;\n    gap: 70px;\n}\n\n.text-content {\n    flex: 1;\n    max-width: 500px;\n}\n\n.hero-title {\n    font-size: 40px;\n    line-height: 1.2;\n    margin-bottom: 24px;\n    font-family: 'GlitchGoblin', sans-serif;\n    text-align: left;\n    color: #FFFFFF;\n}\n\n.hero-description {\n    font-size: 15px;\n    line-height: 1.6;\n    margin: 50px 0px;\n    color: #FFFFFF;\n    max-width: 500px;\n    text-align: left;\n}\n\n.button-group {\n    display: flex;\n    gap: 16px;\n}\n\n.cta-button {\n    padding: 12px 32px;\n    font-size: 16px;\n    border-radius: 5px;\n    font-weight: bold;\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n.primary-cta {\n    background-color: #007bff;\n    color: #FFFFFF;\n    border: none;\n}\n\n.secondary-cta {\n    background-color: transparent;\n    color: #FFFFFF;\n    border: 2px solid #FFFFFF;\n}\n\n.hero-image {\n    flex: 1;\n    max-width: 400px;\n    height: 480px;\n    margin-top: 5%;\n}\n\n/* Mobile View */\n@media (max-width: 768px) {\n    .hero-title {\n        font-size: 40px;\n        margin: 10vh 0vh;\n        text-align: center;\n    }\n    \n    .inner-container {\n        flex-direction: column;\n        text-align: center;\n        gap: 100px;\n        margin-top: 80px;\n    }\n\n    .hero-description {\n        font-size: 18px;\n        max-width: 100%;\n        margin: 80px 10px;\n        text-align: center;\n    }\n\n    .button-group {\n        flex-direction: column;\n        width: 100%;\n        max-width: 400px;\n        align-items: center;\n    }\n\n    .cta-button {\n        width: 100%;\n        text-align: center;\n        height: 60px;\n    }\n\n    .hero-image {\n        max-width: 90%;\n        height: auto;\n    }\n    \n    .text-content {\n        max-width: 100%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        padding: 8vh 2vh;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
